import React, { useContext, useState } from "react";
import { AppContext } from "../../../../../appContext";
import { PopupWrapper } from "../../../../../components/styled/BasicBlocks";
import { SideMenuCommonHeader } from "../SideMenuCommon";
import { InputText } from "../../../../../components/inputText/InputText";
import "./SideMenuAdminCreate.css";
import { createUser } from "../../../../../api/api";

export const SideMenuAdminCreate = ({ onClose }: { onClose: () => void }) => {
    const { translate } = useContext(AppContext);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);
    const [touched, setTouched] = useState({
        email: false,
        password: false,
        firstName: false,
        lastName: false
    });

    const validateEmail = (email: string) => {
        return email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/);
    };

    const validateField = (field: string, value: string) => {
        if (!value) return translate('admin_fill_required');
        if (field === 'email' && !validateEmail(value)) return translate('admin_invalid_email');
        if (field === 'password' && value.length < 6) return translate('admin_password_too_short');
        return '';
    };

    const handleCreate = () => {
        // Отмечаем все поля как "тронутые" при попытке отправки
        setTouched({
            email: true,
            password: true,
            firstName: true,
            lastName: true
        });

        const emailError = validateField('email', email);
        const passwordError = validateField('password', password);
        const firstNameError = validateField('firstName', firstName);
        const lastNameError = validateField('lastName', lastName);

        if (emailError || passwordError || firstNameError || lastNameError) {
            setError(emailError || passwordError || firstNameError || lastNameError);
            return;
        }

        createUser(email, password, firstName, lastName)
        .then(res => res.json())
        .then(data => {
            if (data.success) {
                setSuccess(true);
                setError('');
                // Показываем сообщение об успехе на 3 секунды перед закрытием
                const message = document.createElement('div');
                message.className = 'SideMenuAdminCreate_message';
                message.textContent = translate('admin_create_success');
                
                document.body.appendChild(message);
                setTimeout(() => {
                    document.body.removeChild(message);
                    onClose();
                }, 3000);
                return;
            }
            
            // Если дошли сюда, значит была ошибка
            const errorText = data.message || translate('admin_create_error');
            setError(errorText);
            const errorMessage = document.createElement('div');
            errorMessage.className = 'SideMenuAdminCreate_message SideMenuAdminCreate_message--error';
            errorMessage.textContent = errorText;
            document.body.appendChild(errorMessage);
            setTimeout(() => {
                document.body.removeChild(errorMessage);
            }, 3000);
        })
        .catch((err) => {
            const errorMessage = err.message || translate('admin_create_error');
            setError(errorMessage);
            // Показываем сообщение об ошибке
            const errorElement = document.createElement('div');
            errorElement.className = 'SideMenuAdminCreate_message error';
            errorElement.textContent = translate('admin_create_error');
            document.body.appendChild(errorElement);
            setTimeout(() => {
                document.body.removeChild(errorElement);
            }, 3000);
        });
    }

    return <PopupWrapper className="SideMenuAdminCreate">
        <div className="SideMenuAdminCreate_header">
            <h3>{translate('admin_create_user')}</h3>
        </div>
        <div className="SideMenuAdminCreate_form">
            <InputText
                label={translate('admin_email')}
                value={email}
                onChange={(value) => {
                    setEmail(value);
                    setTouched(prev => ({ ...prev, email: true }));
                }}
                error={touched.email ? (!email ? translate('admin_fill_required') : (!validateEmail(email) ? translate('admin_invalid_email') : '')) : ''}
                className={(touched.email && (!email || !validateEmail(email))) ? 'SideMenuAdminCreate_input--error' : ''}
            />
            <InputText
                label={translate('admin_password')}
                value={password}
                onChange={(value) => {
                    setPassword(value);
                    setTouched(prev => ({ ...prev, password: true }));
                }}
                error={touched.password ? (!password ? translate('admin_fill_required') : (password.length < 6 ? translate('admin_password_too_short') : '')) : ''}
                className={(touched.password && (!password || password.length < 6)) ? 'SideMenuAdminCreate_input--error' : ''}
                type="password"
            />
            <InputText
                label={translate('admin_first_name')}
                value={firstName}
                onChange={(value) => {
                    setFirstName(value);
                    setTouched(prev => ({ ...prev, firstName: true }));
                }}
                error={touched.firstName ? (!firstName ? translate('admin_fill_required') : '') : ''}
                className={(touched.firstName && !firstName) ? 'SideMenuAdminCreate_input--error' : ''}
            />
            <InputText
                label={translate('admin_last_name')}
                value={lastName}
                onChange={(value) => {
                    setLastName(value);
                    setTouched(prev => ({ ...prev, lastName: true }));
                }}
                error={touched.lastName ? (!lastName ? translate('admin_fill_required') : '') : ''}
                className={(touched.lastName && !lastName) ? 'SideMenuAdminCreate_input--error' : ''}
            />
            {success && <div className="SideMenuAdminCreate_success">{translate('admin_create_success')}</div>}
            <button onClick={handleCreate} className="SideMenuAdminCreate_button">
                {translate('admin_create')}
            </button>
        </div>
    </PopupWrapper>
}